import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserStoreService } from './user-store.service';
import { CmdModel } from '../../features/surveys/models/cmd.model';

export interface ApiPostSurveyCmdMappingResponse {
  applied: string[];
  failed: { dbColumn: string; operation: string; reason: string }[];
  isFullSuccess: boolean;
}

export interface CmdMappingRequestModel {
  delete: {csvPosition: number | null; dbColumn: string;}[];
  createOrUpdate: ApiCmdMappingModel[];
}

export interface ApiCmdMappingModel extends CmdModel {
  // Both null for a new record; otherwise the key of the existing record being edited.
  oldCsvPosition: number | null;
  oldDbColumn: string | null;
}

export type ApiSurveyCmdMappingErrorCode = "CME400" | "CME404" | "CME500";

@Injectable({ providedIn: 'root' })
export class ApiSurveyCmdMappingService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/survey/cmdmapping';

  constructor(
    private http: HttpClient,
    private userStore: UserStoreService) {}

  updateSurveyCmdMapping(organizationId: string, surveyId: string, cmdMappingRequest: CmdMappingRequestModel): Observable<ApiPostSurveyCmdMappingResponse> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('This organization/survey is not editable.'));
    }

    const params = new HttpParams()
      .set('organization', organizationId)
      .set('survey', surveyId);

    const request = cmdMappingRequest;

    return this.http.post<ApiPostSurveyCmdMappingResponse>(`${this.apiBaseUrl}${this.apiPath}`, request, {params});
  }
}